// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__PPMQX","img":"button_img__uQjyE","img1":"button_img1__lViEz","btnTitle":"button_btnTitle__HOtu0"};